import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Starts a Stripe Checkout session for a base price lookup_key (plus any accepted
// upsell offers) and redirects. On success the browser navigates away to Stripe.
export async function startCheckout(lookupKey, opts = {}) {
  const { email, upsells } = opts;
  const { data } = await axios.post(`${API}/payments/checkout`, {
    lookup_key: lookupKey,
    origin_url: window.location.origin,
    email: email || undefined,
    upsells: Array.isArray(upsells) ? upsells : [],
  });
  if (data && data.checkout_url) {
    window.location.href = data.checkout_url;
  }
  return data;
}

// Fetches the intelligent, ladder-aware upsell sequence for a base product.
export async function fetchUpsells(lookupKey) {
  const { data } = await axios.get(`${API}/payments/upsells/${lookupKey}`);
  return data; // { base_key, offers: [keys], discount_pct }
}
